import Text from "@ui-kit/typography/Text/Text.web";
import { SeatRemoveTextSharedProps } from "./SeatRemoveText.props";

const SeatRemoveText = ({ title, subtitle }: SeatRemoveTextSharedProps) => {
  return (
    <>
      <Text color="font.dark" fontWeight="bold">
        {title}
      </Text>
      <Text color="font.dark">{subtitle}</Text>
    </>
  );
};

export default SeatRemoveText;
